import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineUploadIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M8.71 7.71 11 5.41V15a1.0001 1.0001 0 0 0 2 0V5.41l2.29 2.3a1.001 1.001 0 0 0 .71.2958 1.0003 1.0003 0 0 0 .71-.2958 1.001 1.001 0 0 0 .2958-.71.9994.9994 0 0 0-.2958-.71l-4-4a.9994.9994 0 0 0-.33-.21 1 1 0 0 0-.76 0 .9994.9994 0 0 0-.33.21l-4 4a1.0041 1.0041 0 1 0 1.42 1.42ZM21 12a1.0001 1.0001 0 0 0-1 1v6a1.0001 1.0001 0 0 1-1 1H5a.9997.9997 0 0 1-1-1v-6a1 1 0 1 0-2 0v6a2.9998 2.9998 0 0 0 3 3h14a3 3 0 0 0 3-3v-6a1.0001 1.0001 0 0 0-1-1Z"/>
  </SvgIcon>
}

export default LineUploadIcon
